import { render, staticRenderFns } from "./YongFa.vue?vue&type=template&id=45ca294a&scoped=true"
import script from "./YongFa.vue?vue&type=script&lang=js"
export * from "./YongFa.vue?vue&type=script&lang=js"
import style0 from "./YongFa.vue?vue&type=style&index=0&id=45ca294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca294a",
  null
  
)

export default component.exports